// extracted by mini-css-extract-plugin
export default {"ricosDisabled":"yK2zAh","checkbox":"_4MwPrw"};